const en = {
  index: {
    webContra: '藏漢比對',
    cateList: '經書列表',
    aboutContrast: '關於藏漢比對',
    aboutTeam: '關於我們',
  },
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en/homepage.js